export interface Notification {
  name: string;
  label: string;
  icon: string;
}

export const REP_NOTIFICATIONS: Array<Notification> = [
  { name: 'reputationIncreased', icon: 'far fa-thumbs-up', label: 'Reputation' },
  { name: 'reputationDecreased', icon: 'far fa-thumbs-down', label: 'Reputation decreased' },
  { name: 'reputationIncreasedForDiscussion', icon: 'far fa-thumbs-up', label: 'Reputation increased for new discussion' },
  { name: 'reputationDecreasedForDiscussion', icon: 'far fa-thumbs-down', label: 'Reputation decreased for discussion lock' },
  { name: 'reputationIncreasedForBestAnswer', icon: 'far fa-thumbs-up', label: 'Reputation Increased for best answer' },
  { name: 'reputationDecreasedForBestAnswer', icon: 'far fa-thumbs-down', label: 'Reputation decreased for best answer reverted' },
  { name: 'reputationIncreasedForFlag', icon: 'far fa-thumbs-up', label: 'Reputation increased for reporting an user/post' },
];
